export default [
  {
    path: '/relVendasPorRecebimento/',
    name: 'relVendasPorRecebimento',
    title: 'relVendasPorRecebimento',
    component: () => import('../views/RelVendasPorRecebimentoView.vue'),
    redirect: { name: 'relVendasPorRecebimento-listar' },
    children: [
      {
        path: 'welcome',
        name: 'relVendasPorRecebimento-listar',
        component: () => import('../views/RelVendasPorRecebimentoWelcomeView.vue'),
        meta: {
          title: 'Relatório de vendas por tipo de recebimento',
        },
      },
    ],
  },
];
